import moment from 'moment';
import { MouseEvent as ReactMouseEvent } from 'react';
import { useNavigate } from 'react-router';
import { Box, Center, Column, Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Divider } from '~/commonComponents';
import { useJobProfessionDisplay } from '~/hooks';
import { CloseCircleSolidIcon, ContinueCircleIcon } from '~/images/icons';
import { ProfessionTypeEnum } from '~/models';
import './styles.scss';
import { IDraftJobCardProps } from './Types';

export const DraftJobCard = ({
  id,
  lastSavedAt,
  office,
  officeSelected,
  professionType,
  subProfession,
  title,
  onDeleteDraft,
}: IDraftJobCardProps) => {
  const navigate = useNavigate();

  const professionToDisplay = useJobProfessionDisplay({
    profession: professionType || ProfessionTypeEnum.RDH,
    subProfession,
  });

  const handleContinueClick = () => {
    navigate(`/permanent-jobs/postings/${id}/create`);
  };

  const handleDeleteClick = (e: ReactMouseEvent<HTMLElement>) => {
    e.preventDefault();
    e.stopPropagation();

    onDeleteDraft?.(id);
  };

  return (
    <Box
      className="draft-job-card grid items-center cursor-pointer shadow-xs hover__shadow-sm bg-shades-0 rounded-field relative"
      data-cy="draft-job-card"
      py={3}
      style={{ gridTemplateColumns: '1fr 20%' }}
      onClick={handleContinueClick}
    >
      <Column gap={2} style={{ marginLeft: 36 }}>
        <Typography as="span" bold style={{ textDecoration: 'underline' }}>
          {title || 'UNTITLED'}
        </Typography>
        <Typography as="span">{officeSelected ? office?.name || 'No Office Selected' : 'No Office Selected'}</Typography>
        <Row align="center" gap={3}>
          <Typography as="span">
            {professionType
              ? professionToDisplay || 'No Professional Type Selected'
              : 'No Professional Type Selected'}
          </Typography>
          <Divider width={1} height={12} marginVertical={0} />
          <Typography italic color={colors.neutral[400]} style={{ fontSize: 14 }}>
            Draft saved on {moment(lastSavedAt).format('ddd, MMM D, YYYY')}
          </Typography>
        </Row>
      </Column>
      <Row
        align="center"
        className="continue-btn"
        gap={2}
        justify="end"
        role="button"
        style={{ marginRight: 36 }}
      >
        <ContinueCircleIcon />
        <Typography as="span" bold size="body_large">
          Continue
        </Typography>
      </Row>
      <Center
        className="delete-btn absolute cursor-pointer"
        data-cy="draft-job-card-delete-button"
        role="button"
        onClick={handleDeleteClick}
        style={{
          right: -8,
          top: -8,
          padding: 1,
          filter:
            'drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.1)) drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.1))',
        }}
      >
        <CloseCircleSolidIcon size={32} />
      </Center>
    </Box>
  );
};
